module.exports = __webpack_public_path__ + "static/phone-ce7c3125c171fb4b4b8d7d5c47330eac.png";